import { primaryCode, secondaryCode, reducedSpacesCode } from './accordionsCode';
import { primaryLayout, secondaryLayout, reducedSpacesLayout } from './accordionsLayouts';

const accordionsSet = [
  {
    component: primaryLayout,
    codeTemplate: primaryCode,
    previewClass: 'block',
    optionsGroup: [
      {
        label: 'Primary',
        options: [
          {label: 'White', type: 'radio', options: {bgColor: 'heavy-blue', bgGrey: false}},
          {label: 'BG Grey', type: 'radio', options: {bgColor: 'heavy-blue', bgGrey: true}}
        ]
      },
      {
        label: 'Text Boxes:',
        options: [
          {label: 'Text Boxes', type: 'dropdown', selectList: [
            {label: '1 Text Box', value: '1-text-box', options: {
              infoSection: [
                {label: 'Label', text: 'Max-width: 176px'}
              ]
            }},
            {label: '2 Text Box', value: '2-text-box', options: {
              infoSection: [
                {label: 'Label', text: 'Max-width: 176px'},
                {label: 'Label', text: 'Max-width: 176px'}
              ]
            }}
          ],
          }
        ]
      }
    ]
  },
  {
    component: secondaryLayout,
    codeTemplate: secondaryCode,
    previewClass: 'block',
    optionsGroup: [
      {
        label: 'Secondary',
        options: [
          {label: 'White', type: 'radio', options: {bgColor: 'heavy-blue', bgGrey: false}},
          {label: 'BG Grey', type: 'radio', options: {bgColor: 'heavy-blue', bgGrey: true}}
        ]
      },
      {
        label: 'Text Boxes:',
        options: [
          {label: 'Text Boxes', type: 'dropdown', selectList: [
            {label: '1 Text Box', value: '1-text-box', options: {
              infoSection: [
                {label: '(LABEL) JUSTO NEC ULTRICES DUI', text: 'Rs. 00,000,000.00'}
              ]
            }},
            {label: '2 Text Box', value: '2-text-box', options: {
              infoSection: [
                {label: '(LABEL) JUSTO NEC ULTRICES DUI', text: 'Rs. 00,000,000.00'},
                {label: '(LABEL) JUSTO NEC ULTRICES DUI', text: 'Rs. 00,000,000.00'}
              ]
            }},
            {label: '3 Text Box', value: '3-text-box', options: {
              infoSection: [
                {label: '(LABEL) JUSTO NEC ULTRICES DUI', text: 'Rs. 00,000,000.00'},
                {label: '(LABEL) JUSTO NEC ULTRICES DUI', text: 'Rs. 00,000,000.00'},
                {label: '(LABEL) JUSTO NEC ULTRICES DUI', text: 'Rs. 00,000,000.00'}
              ]
            }}
          ],
          }
        ]
      }
    ]
  },
  {
    component: reducedSpacesLayout,
    codeTemplate: reducedSpacesCode,
    previewClass: 'block',
    optionsGroup: [
      {
        label: 'Reduced Spaces',
        options: [
          {label: 'White', type: 'radio', options:{bgColor: 'heavy-blue', bgGrey: false}},
          {label: 'BG Grey', type: 'radio', options:{bgColor: 'heavy-blue', bgGrey: true}}
        ]
      }
    ]
  }
];

export default accordionsSet;



// WEBPACK FOOTER //
// ./src/containers/components/Accordion/constants/accordionsSet.js